// src/components/Dashboard/LowStockAlerts.jsx
import React from 'react';

export default function LowStockAlerts({ products }) {
  const data = products || [];

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-red-600">Low Stock Alerts</h3>
      </div>
      <div className="divide-y divide-gray-200">
        {data.length === 0 ? (
          <div className="p-6 text-center text-gray-500">No low stock items</div>
        ) : (
          data.map((product, index) => (
            <div key={index} className="p-4">
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-medium">{product.name}</p>
                  <p className="text-sm text-gray-500">SKU: {product.sku}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-red-600 font-semibold">Stock: {product.current_stock}</p>
                  <p className="text-xs text-gray-500">Min: {product.min_stock_level}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}